import React from "react";
import { TriangleAlert } from "lucide-react";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import OptionMenu from "./OptionMenu";
import "./messageStyles.css";

interface OptionsMenuWithErrorProps {
  error?: boolean;
  handleResend?: () => void;
  handleDelete?: () => void;
  children: React.ReactNode;
  lockNode?: React.ReactNode;
}

const OptionMenuWithError: React.FC<OptionsMenuWithErrorProps> = ({
  error,
  handleResend,
  handleDelete,
  children,
  lockNode,
}) => {
  return (
    <div className="flex flex-row items-center group justify-end w-full">
      <div className="options-menu">
        <OptionMenu
          error={error}
          handleResend={handleResend}
          handleDelete={handleDelete}
        />
        <TooltipProvider>
          <Tooltip>
            <TooltipTrigger>
              {error && (
                <TriangleAlert size={24} className="text-red-400 mr-2" />
              )}
            </TooltipTrigger>
            <TooltipContent>
              <p className="text-neutral-500">Failed to send message</p>
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>
      </div>
      {lockNode}
      {children}
    </div>
  );
};

export default OptionMenuWithError;
